import React from 'react';
import { SectionTitle, InfoCard } from './BrandedVoucherLayout';
import VoucherBarcodeStrip from './VoucherBarcodeStrip';
import ActivityVoucherBodyV2 from './ActivityVoucherBody';
import { formatVoucherDate } from '../../lib/voucherDate';

// Activity voucher uses the redesigned premium body (Phase 8.21).
// Hotel / Flight / Transfer / Itinerary keep their existing layouts.
export const ActivityVoucherBody = ActivityVoucherBodyV2;

export function TransferVoucherBody({ voucher, company }) {
  const t = voucher?.transfer || {};
  const primary = company?.primaryColor || '#34D0CB';
  const accent = company?.accentColor || '#595A5B';
  const orig = voucher?.originalCode;
  const barcodeValue = (orig?.value || t.bookingRef || t.confirmationNumber || voucher?.voucherId || 'TRV').toString();
  const codeKind = orig?.kind || 'barcode';
  const codeImage = orig?.imageBase64 || '';
  return (
    <>
      <div className="flex items-end justify-between mb-4">
        <SectionTitle primary={primary}>Transfer Details</SectionTitle>
        <VoucherBarcodeStrip value={barcodeValue} imageBase64={codeImage} accent={accent} label="Booking" kind={codeKind} />
      </div>

      <div className="grid grid-cols-2 gap-3 mb-6">
        <div className="p-5 rounded-xl" style={{ background: `${primary}0F`, border: `1px solid ${primary}33` }}>
          <div className="text-[9px] font-semibold uppercase" style={{ letterSpacing: '0.2em', color: accent }}>Pickup</div>
          <div className="text-lg font-bold mt-2" style={{ color: '#111827' }}>{t.pickupLocation || t.pickup || '—'}</div>
          {(t.pickupDateTime || t.date) && <div className="text-xs mt-2" style={{ color: accent }}>{t.pickupDateTime || `${formatVoucherDate(t.date)}${t.time ? ' · ' + t.time : ''}`}</div>}
        </div>
        <div className="p-5 rounded-xl" style={{ background: `${primary}0F`, border: `1px solid ${primary}33` }}>
          <div className="text-[9px] font-semibold uppercase" style={{ letterSpacing: '0.2em', color: accent }}>Drop-off</div>
          <div className="text-lg font-bold mt-2" style={{ color: '#111827' }}>{t.dropLocation || t.drop || '—'}</div>
          {t.dropDateTime && <div className="text-xs mt-2" style={{ color: accent }}>{t.dropDateTime}</div>}
        </div>
      </div>

      <div className="grid grid-cols-3 gap-3">
        <InfoCard label="Vehicle" value={t.vehicleType} primary={primary} accent={accent} />
        <InfoCard label="Passengers" value={t.passengers || 1} primary={primary} accent={accent} />
        <InfoCard label="Flight Reference" value={t.flightRef || '—'} primary={primary} accent={accent} mono />
        <InfoCard label="Driver" value={t.driverName || 'TBD'} primary={primary} accent={accent} />
        <InfoCard label="Driver Contact" value={t.driverPhone || 'TBD'} primary={primary} accent={accent} mono />
        <InfoCard label="Booking Ref" value={t.bookingRef} primary={primary} accent={accent} mono />
      </div>
    </>
  );
}

export function ItineraryVoucherBody({ voucher, company }) {
  const it = voucher?.itinerary || {};
  const days = Array.isArray(it.dayWise) ? it.dayWise : [];
  const primary = company?.primaryColor || '#34D0CB';
  const accent = company?.accentColor || '#595A5B';
  const orig = voucher?.originalCode;
  const barcodeValue = (orig?.value || voucher?.voucherId || 'TRV').toString();
  const codeKind = orig?.kind || 'barcode';
  const codeImage = orig?.imageBase64 || '';
  return (
    <>
      <div className="flex items-end justify-between mb-4">
        <SectionTitle primary={primary}>Itinerary Summary</SectionTitle>
        <VoucherBarcodeStrip value={barcodeValue} imageBase64={codeImage} accent={accent} label="Itinerary" kind={codeKind} />
      </div>
      {it.summary && (
        <div className="text-xs leading-relaxed mb-6 p-4 rounded-xl"
          style={{ color: accent, background: `${primary}08`, border: `1px solid ${primary}22` }}>
          {it.summary}
        </div>
      )}
      {days.length > 0 && (
        <>
          <SectionTitle primary={primary}>Day-Wise Plan</SectionTitle>
          <div className="space-y-3">
            {days.map((d, i) => (
              <div key={i} className="day-card p-4 rounded-xl" style={{ background: '#FAFAFA', border: '1px solid #E5E7EB' }}>
                <div className="flex items-baseline gap-3 mb-1">
                  <div className="text-[10px] font-bold uppercase px-2 py-0.5 rounded" style={{ background: primary, color: '#FFFFFF', letterSpacing: '0.1em' }}>
                    Day {d.day || i + 1}
                  </div>
                  <div className="text-sm font-semibold" style={{ color: '#111827' }}>{d.title}</div>
                </div>
                {d.description && <div className="text-xs mt-1" style={{ color: accent }}>{d.description}</div>}
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
}
